import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import styles from './CreateNewPassword.module.scss';
import Button from '../../common/Button';
import Input from '../../blocks/Input';
import { requiredValidator, passwordValidator, isFormValid } from '../../../utils/validators';
import { useDispatch } from 'react-redux';
import { shouldResetPassword } from '../../../store/actions/auth';
import { resetPasswordErrorMessage } from '../../../store/actions/createNewPassword';
import { exitIcon } from '../../common/Icons/exit.icon';
import PasswordRequirements from '../PasswordRequirements';

const validators = [
  {
    key: 'password',
    validator: [requiredValidator, passwordValidator],
  },
];

function CreateNewPassword(props) {
  const { errorCode, roles } = props;
  const dispatch = useDispatch();

  let [password, setPassword] = useState('');

  const last4PasswordsRequirementCheck = useMemo(() => {
    if (errorCode === 'PASSWORD_USED_BEFORE') return true;
  }, [errorCode]);

  const renderError = (errorCode) => {
    switch (errorCode) {
      case 'INVALID_TOKEN':
        return 'No such token or token expired. please try to recover your password again.';

      case 'PASSWORD_USED_BEFORE':
        return '';

      case 'INSECURE_PASSWORD':
        return "Password isn't secure enough. Please follow instructions.";

      default:
        return 'Cannot reset password.';
    }
  };

  const handleSubmit = (e) => {
    props.createNewPassword(password);
    dispatch(shouldResetPassword(false));
    e.preventDefault();
  };

  const buttonDisabled = () => !isFormValid({ ...roles, password }, validators);

  const renderPasswordRequirements = () => {
    const form = { ...roles, password };
    const missedRequirement = passwordValidator(password, form).missedRequirement;
    return (
      <PasswordRequirements
        isPasswordBeingSet={password.length}
        isMissingRequirement={{
          last4PasswordsRequirement: last4PasswordsRequirementCheck,
          ...missedRequirement,
        }}
      />
    );
  };

  return (
    <>
      <div className={styles.header}>
        <p>
          {exitIcon}
          <Link to="/signin">Sign In</Link>
        </p>
      </div>
      <form className={styles.form} onSubmit={handleSubmit}>
        <h2>Create New Password</h2>
        <Input
          type="password"
          onChange={(e) => {
            setPassword(e.target.value);
            dispatch(resetPasswordErrorMessage(''));
          }}
          placeholder="New password"
          marginBottom
          value={password}
          form={roles}
          validate={[requiredValidator, passwordValidator]}
          autocomplete="new-password"
        />

        {renderPasswordRequirements()}

        <div className={styles.settings}>
          <span className={styles.errorMessage}>{errorCode ? renderError(errorCode) : ''}</span>
        </div>

        <div className={styles.submitButton}>
          <Button type="submit" text="Reset Password" disabled={buttonDisabled()} />
        </div>
      </form>
    </>
  );
}

export default CreateNewPassword;

CreateNewPassword.propTypes = {
  createNewPassword: PropTypes.func.isRequired,
};
